export default __webpack_public_path__ + "static/media/03.66b4e0f9.png";